import React, { useEffect, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { StyledButton } from "../../components/styledComponent/styledElements";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { Button } from "antd";

import CustomTable from "../../components/styledComponent/styledTable";
import TableActions from "../../components/tableAction/tableActions";
import {
  deleteBanner,
  getAllBanner,
  setFavouriteBanner,
} from "../../server/bannerServices";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import { PRIMARY_THEME } from "../../constants/constant";
import { ShowNotification } from "../../components/notification/notification";
import DeleteModal from "../../components/styledComponent/deleteModal";
import BannerCreationModal from "./bannerCreationModal";
import ImagePreview from "../../components/preview/imagePreview";
import { useAppContext } from "../../contexts/appContext";

export default function BannerPage() {
  const column = [
    {
      dataIndex: "is_fav",
      key: "is_fav",
      hidden: userRole === "Admin" || bannerPermission?.edit,
      render: (fav, record) =>
        fav ? (
          <Button
            className="icon-only-button"
            icon={<MdFavorite size={24} color={PRIMARY_THEME} />}
            onClick={() => unFavouriteBanner(record.id, record)}
          />
        ) : (
          <Button
            className="icon-only-button"
            icon={<MdFavoriteBorder size={24} />}
            onClick={() => favouriteBanner(record.id, record)}
          />
        ),
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) => <img width={100} src={image.url} alt={image.name} />,
      onCell: (record) => ({
        onClick: () => handleBannerClick(record.image.url),
        className: "clickable",
      }),
    },
    {
      title: "Name",
      dataIndex: "image_name",
      key: "image_name",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
    },

    {
      key: "actions",
      width: 100,
      render: (_, record) => (
        <TableActions
          showDelete={userRole === "Admin" || bannerPermission?.delete}
          onClickDelete={(e) => {
            e.stopPropagation();
            setDeleteId(record.id);
            setShowDeletePopup(true);
          }}
        />
      ),
    },
  ];
  const { startLoading, stopLoading, user } = useAppContext();

  const [addBannerModal, setaddBannerModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  var userRole = user?.role;
  var bannerPermission = user?.access?.banner;

  const handleBannerClick = (imageUrl) => {
    setPreviewImage(imageUrl);
    setPreviewOpen(true);
  };
  const fetchBanners = () => {
    startLoading();
    getAllBanner()
      .then((res) => {
        const formattedData = res.data.map((item) => ({
          id: item.banner.id,
          image: item.image,
          image_name: item.image.name,
          created_at: item.banner.created_at,
          is_fav: item.banner.is_fav,
        }));
        setTableData(formattedData);
        setRefetch(false);
      })
      .catch((err) => console.log("Error on fetching products", err))
      .finally(() => stopLoading());
  };
  useEffect(() => {
    fetchBanners();
  }, [refetch]);

  const favouriteBanner = (id, record) => {
    setFavouriteBanner(id, true).then(() => {
      ShowNotification({
        type: "success",
        message: "Banner successfully added to favourites",
      });
      setRefetch(true);
    });
  };
  const unFavouriteBanner = (id, record) => {
    setFavouriteBanner(id, false).then(() => {
      ShowNotification({
        type: "success",
        message: "Banner successfully removed from favourites",
      });
      setRefetch(true);
    });
  };
  const handleDeleteBanner = () => {
    deleteBanner(deleteId).then(() => {
      ShowNotification({
        type: "success",
        message: "Banner Deleted Successfully ",
      });
      setRefetch(true);
      setShowDeletePopup(false);
      setDeleteId(null);
    });
  };
  return (
    <div>
      {showDeletePopup && (
        <DeleteModal
          showDelete={showDeletePopup}
          onCancel={() => {
            setDeleteId(null);
            setShowDeletePopup(false);
          }}
          onsubmit={handleDeleteBanner}
        />
      )}
      {addBannerModal && (
        <BannerCreationModal
          showModal={addBannerModal}
          setShowModal={setaddBannerModal}
          setRefetch={setRefetch}
        />
      )}
      {previewOpen && (
        <ImagePreview
          previewOpen={previewOpen}
          previewImage={previewImage}
          setPreviewOpen={setPreviewOpen}
        />
      )}
      <StyledContentCard title={"Banner"}>
        <div className="flex float-right mb-2 gap-2">
          {(userRole === "Admin" || bannerPermission?.create) && (
            <StyledButton
              icon={<AiOutlinePlusSquare size={20} />}
              iconPosition="start"
              onClick={() => setaddBannerModal(true)}
            >
              Banner
            </StyledButton>
          )}
        </div>
        <CustomTable data={tableData} columns={column} rowKey="id" />
      </StyledContentCard>
    </div>
  );
}
